import { useParams } from 'react-router-dom';
import { useApplication } from '~/data';
import { useSchoolCustomizations } from '~/data/useSchoolCustomizations';
import { Flex, Spinner } from '@applyboard/crystal-ui';
import { ApplicationDetailsLayout } from './layouts';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';
import { ApplicationDetailContext } from './context';
import { ErrorHandler } from '../ErrorPage';

export function ApplicationDetailsPage() {
  useWindowDocumentTitle('Application Details');
  const applicationId = useApplicationId();
  const { application, isLoadingApplication, applicationError, isApplicationError } = useApplication(applicationId);
  const { schoolCustomizations, isSchoolCustomizationsLoading, isSchoolCustomizationsError } =
    useSchoolCustomizations();
  if (
    (!isApplicationError && isLoadingApplication) ||
    (!isSchoolCustomizationsError && isSchoolCustomizationsLoading)
  ) {
    return (
      <Flex p={5} gap={5} align="center" direction="column" role="progressbar">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (isApplicationError || !application || isSchoolCustomizationsError || !schoolCustomizations) {
    return (
      <ErrorHandler
        error={applicationError}
        customMessage="Failed to fetch the application details or school customizations."
      />
    );
  }

  return (
    <ApplicationDetailContext application={application} schoolCustomizations={schoolCustomizations}>
      <ApplicationDetailsLayout />
    </ApplicationDetailContext>
  );
}

function useApplicationId() {
  const { id } = useParams() as { id: string };
  return id;
}
